'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = function Close(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    'a',
    { className: 'quiver-modal-container__close', onClick: onClick },
    _react2.default.createElement(
      'svg',
      { viewBox: '0 0 14 14' },
      _react2.default.createElement('line', { x1: '0', y1: '0', x2: '14', y2: '14' }),
      _react2.default.createElement('line', { x1: '14', y1: '0', x2: '0', y2: '14' })
    )
  );
};

Close.propTypes = {
  onClick: _propTypes2.default.func
};

Close.defaultProps = {
  onClick: null
};

exports.default = Close;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ModalContainer/Close.js
// module id = 294
// module chunks = 0